import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

export const caregiverAvailable = (caregiver, targetDate, targetTimezone) => {
  if (!caregiver || !caregiver?.Availability) return false;

  // Convert the target date/timezone to the caregiver timezone
  const time = dayjs(targetDate, caregiver.Timezone);
  let day = time.day();
  return caregiver.Availability.some((a) => a.Day === day && a.Enabled);
};
